export const responseErrorFormatter = (responseErrors, errorsObj = {}) => {
    Object.keys(responseErrors).forEach((key, index) => {
        let keys = key.split('.');

        const arrPos = [];
        keys.forEach((key, index) => {
            if (Number.isInteger(parseInt(key))) {
                arrPos.push(index);
            }
        });

        if (arrPos.length > 0) {
            arrPos.forEach((pos) => {
                keys = [keys[pos - 1], keys[pos], keys[pos + 1]];
                keyValueAssigner(errorsObj, keys, responseErrors[key]);
            });
        } else {
            keyValueAssigner(errorsObj, keys, responseErrors[key]);
        }
    });

    return errorsObj;
};

export const formatResponseErrorsForFormik = (responseErrors) => {
    const formattedErrorObject = {};
    Object.keys(responseErrors).forEach((key, index) => {
        // eslint-disable-next-line prefer-destructuring
        formattedErrorObject[key] = responseErrors[key][0];
    });
    return formattedErrorObject;
};

const keyValueAssigner = (errorsObj, keys, values) => {
    const lastKeyIndex = keys.length - 1;
    for (let i = 0; i < lastKeyIndex; ++i) {
        const key = keys[i];
        if (!(key in errorsObj)) {
            errorsObj[key] = {};
        }
        errorsObj = errorsObj[key];
    }

    return (errorsObj[keys[lastKeyIndex]] = values);
};
